<template>
  <row>
    <column class="col-md-6">
      <va-box title="Search new printers scheduler" :isBorder="true" theme="box-warning" widgetType="">
        <div slot="content">
          <form class="form-horizontal">
            <div class="form-group">
              <label class="col-sm-4 control-label" style="text-align: left;">Search Printers Every </label>
              <div class="col-sm-5">
                <input type="number" min="1" max="28" class="form-control" style="text-align: center;" placeholder="Days" v-model="settingsData.SettingsArray.SearchPrintersEvery" />
              </div>
              <label class="col-sm-1 control-label">Days</label>
            </div>
            <div class="form-group">
              <label class="col-sm-4 control-label" style="text-align: left;">Send Counters Every </label>
              <div class="col-sm-5">
                <input type="number" min="1" max="28" class="form-control" style="text-align: center;" placeholder="Days" v-model="settingsData.SettingsArray.SendPrintersEvery" />
              </div>
              <label class="col-sm-1 control-label">Days</label>
            </div>
          </form>
        </div>
      </va-box>
      <va-box title="Get printers info scheduler" :isBorder="true" theme="box-warning" widgetType="">
        <div slot="content">
          <form class="form-horizontal">
            <div class="form-group">
              <label class="col-sm-4 control-label" style="text-align: left;">Search Printers Every </label>
              <div class="col-sm-5">
                <input type="number" min="1" max="28" class="form-control" style="text-align: center;" placeholder="Days" v-model="settingsData.SettingsArray.SearchPrintersEvery" />
              </div>
              <label class="col-sm-1 control-label">Days</label>
            </div>
            <div class="form-group">
              <label class="col-sm-4 control-label" style="text-align: left;">Send Counters Every </label>
              <div class="col-sm-5">
                <input type="number" min="1" max="28" class="form-control" style="text-align: center;" placeholder="Days" v-model="settingsData.SettingsArray.SendPrintersEvery" />
              </div>
              <label class="col-sm-1 control-label">Days</label>
            </div>
          </form>
        </div>
      </va-box>
      <va-box title="Counter Configurations" :isBorder="true" theme="box-warning" widgetType="">
        <div slot="content">
          <form class="form-horizontal">
            <div class="form-group">
              <label class="col-sm-4 control-label" style="text-align: left;">Search Printers Every </label>
              <div class="col-sm-5">
                <input type="number" min="1" max="28" class="form-control" style="text-align: center;" placeholder="Days" v-model="settingsData.SettingsArray.SearchPrintersEvery" />
              </div>
              <label class="col-sm-1 control-label">Days</label>
            </div>
            <div class="form-group">
              <label class="col-sm-4 control-label" style="text-align: left;">Send Counters Every </label>
              <div class="col-sm-5">
                <input type="number" min="1" max="28" class="form-control" style="text-align: center;" placeholder="Days" v-model="settingsData.SettingsArray.SendPrintersEvery" />
              </div>
              <label class="col-sm-1 control-label">Days</label>
            </div>
          </form>
        </div>
      </va-box>
      <va-box title="Rules" :isBorder="true" theme="box-warning" widgetType="">
        <div slot="content">
          <div class="table-responsive">
            <table class="table no-margin">
              <thead>
                <tr>
                  <th>Rule</th>
                  <th>Condition</th>
                  <th>Action</th>
                  <th></th>
                </tr>
              </thead>
              <tbody v-if="hasData">
                <tr v-for="(item,index) in rulesList">
                  <td>{{item.Rule}}</td>
                  <td>{{item.Condition}}</td>
                  <td>{{item.Action}}</td>
                  <td style="text-align: right; width: 80px;">
                    <a class="btn-flat danger" style="margin-left: 10px; cursor: pointer;" title="Edit">
                      <i class="fa fa-edit" style="font-size: 20px; color:green;"></i>
                    </a>
                    <a class="btn-flat danger" style="margin-left: 10px; cursor: pointer;" title="Delete">
                      <i class="fa fa-trash-o" style="font-size: 20px; color:red;"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </va-box>
    </column>
    <column class="col-md-6">
      <va-box title="Rules" :isBorder="true" theme="box-warning" widgetType="">
        <div slot="content">
          <div class="table-responsive">
            <table class="table no-margin">
              <thead>
                <tr>
                  <th>Rule</th>
                  <th>Condition</th>
                  <th>Action</th>
                  <th></th>
                </tr>
              </thead>
              <tbody v-if="hasData">
                <tr v-for="(item,index) in rulesList">
                  <td>{{item.Rule}}</td>
                  <td>{{item.Condition}}</td>
                  <td>{{item.Action}}</td>
                  <td style="text-align: right; width: 80px;">
                    <a class="btn-flat danger" style="margin-left: 10px; cursor: pointer;" title="Edit">
                      <i class="fa fa-edit" style="font-size: 20px; color:green;"></i>
                    </a>
                    <a class="btn-flat danger" style="margin-left: 10px; cursor: pointer;" title="Delete">
                      <i class="fa fa-trash-o" style="font-size: 20px; color:red;"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </va-box>
      <va-box title="Counter Configurations" :isBorder="true" theme="box-warning" widgetType="">
        <div slot="content">
          <form class="form-horizontal">
            <div class="form-group">
              <label class="col-sm-4 control-label" style="text-align: left;">Search Printers Every </label>
              <div class="col-sm-5">
                <input type="number" min="1" max="28" class="form-control" style="text-align: center;" placeholder="Days" v-model="settingsData.SettingsArray.SearchPrintersEvery" />
              </div>
              <label class="col-sm-1 control-label">Days</label>
            </div>
            <div class="form-group">
              <label class="col-sm-4 control-label" style="text-align: left;">Send Counters Every </label>
              <div class="col-sm-5">
                <input type="number" min="1" max="28" class="form-control" style="text-align: center;" placeholder="Days" v-model="settingsData.SettingsArray.SendPrintersEvery" />
              </div>
              <label class="col-sm-1 control-label">Days</label>
            </div>
          </form>
        </div>
      </va-box>
    </column>
  </row>
</template>
<script>
  import VABox from '../widgets/VABox'
  import VAInputGroup from '../components/VAInputGroup'
  import VACheckBox from '../components/VACheckBox'
  import VAInput from '../components/VAInput'
  import VAButton from '../components/VAButton'
  import VATextareaGroup from '../components/VATextareaGroup'
  import VAFormGroup from '../components/VAFormGroup'
  import VARadio from '../components/VARadio'
  import VASelect from '../components/VASelect'

  export default {
    name: 'settingsDealer',
    props: ['settingsData'],
    components: {
      'va-box': VABox,
      'va-input-group': VAInputGroup,
      'va-checkbox': VACheckBox,
      'va-input': VAInput,
      'va-button': VAButton,
      'va-textarea-group': VATextareaGroup,
      'va-form-group': VAFormGroup,
      'va-radio': VARadio,
      'va-select': VASelect
    },
    data () {
      return {
        rulesList: [
          { Rule: 'Printer Status Changed', Condition: 'Equal(\'Error\')', Action: 'Send Alert Email' },
          { Rule: 'Printer Status', Condition: 'Equal(\'Error\')', Action: 'Send Alert Email' },
          { Rule: 'Printer Status', Condition: 'Equal(\'Error\')', Action: 'Send Alert Email' },
          { Rule: 'Printer Status', Condition: 'Equal(\'Error\')', Action: 'Send Alert Email' },
          { Rule: 'Printer Status', Condition: 'Equal(\'Error\')', Action: 'Send Alert Email' }
        ]
      }
    },
    computed: {
      hasData () {
        return this.rulesList
      }
    },
    created () {
      this.$root.title = 'Settings'
    },
    methods: {
    }
  }
</script>




// WEBPACK FOOTER //
// SettingsDealer.vue?758066ba